import React from 'react'

import AllIdeas from '../../../react4xp/components/Idea/AllIdeas'

function ListIdeasPart({title, cta, ideasLiked, colors, endpoint, startValues, strings, services, isLogged}) {
  return (
    <AllIdeas
		title={title}
		endpoint={endpoint}
		services={services}
		viewAll={cta}
		ideasLiked={ideasLiked}
		startValues={startValues}
		loadMore={{
			text: strings.loadMore
		}}
		totalText={{
			of: strings.of,
			text: strings.ideas
		}}
		section={{
			bgColor: colors.bgColor,
			paddingTop: 'big'
		}}
		isWhite={colors.isWhite}
		isLogged={isLogged}
    />
  )
}

export default (props) => <ListIdeasPart {...props} />
